
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import STPMasterQualityParameterDataPopup from './MasterQualityParameterDataPopup'
import { useSearchParams } from 'react-router-dom'
import { STPParameterTypeDataDDL } from '../../../../../../Components/CommonDDL/STPParameterTypeDDL'
import { STPQualityParameterNameDataDDL } from '../../../../../../Components/CommonDDL/STPQualityParameterNameDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { STPQualityParameterDeleteAPI, STPQualityParameterTableDataAPI, STPQualityParameterTableExportDataAPI } from '../../../../../../Redux/STPDashboardSlice/STPMaster/STPQualityParameterSlice'
import { STPQualityParameterExportData } from './MasterQualityParameterExportData'




export default function STPQualityParameterData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [STPMasterQualityParameterDataPopupShow, setSTPMasterQualityParameterDataPopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    // const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const [ParameterType, setParameterType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [QualityParameterName, setQualityParameterName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })



    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSTPMasterQualityParameterDataPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSTPMasterQualityParameterDataPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setSTPMasterQualityParameterDataPopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setParameterType({
            ...ParameterType,
            ID: 0,
            Label: 'Select...',
        })
        setQualityParameterName({
            ...QualityParameterName,
            ID: 0,
            Label: 'Select...',
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        // setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            M_IndicatorParameterTypeID: ParameterType.ID,
            M_STP_QualityParameterID: QualityParameterName.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handleSTPQualityParameterExport:handleSTPQualityParameterExport
        }
        dispatch(STPQualityParameterTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.STPQualityParameterTableData)

    const handleSTPQualityParameterExport = () => {
        const data = {
            M_IndicatorParameterTypeID: ParameterType.ID,
            M_STP_QualityParameterID: QualityParameterName.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: "99999",
        }
        dispatch(STPQualityParameterTableExportDataAPI({ data }))
    }
    // , [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.STPQualityParameterTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            M_STP_QualityParameterID: item.m_stP_QualityParameterID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(STPQualityParameterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.STPQualityParameterDelete)


    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId} />
                <div className="content">
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Quality Parameter</h5>
                                <div className="float-end butt">
                                    {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            tableData && tableData.table && tableData.table.length > 0 &&
                                            <STPQualityParameterExportData
                                                ExcelData={ExportTableData}
                                                name='Quality Parameter'
                                            // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12 mb-5">

                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-lg-4 col-md-4">
                                                <STPParameterTypeDataDDL
                                                    ParameterType={ParameterType}
                                                    setParameterType={setParameterType}
                                                // WardName={WardName}
                                                // IsPost={IsPost}
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-12 col-lg-4 col-md-4">
                                                <STPQualityParameterNameDataDDL
                                                    QualityParameterName={QualityParameterName}
                                                    setQualityParameterName={setQualityParameterName}
                                                    ParameterType={ParameterType}
                                                // IsPost={IsPost}
                                                // Flag='ward'
                                                />

                                            </div>


                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-1" >

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Parameter Type</th>
                                                        <th>Quality Parameter Name</th>
                                                        <th className='action_icon action-col'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td className='char-col'>{item.indicatorName ? item.indicatorName : '-'}</td>
                                                                <td>{item.qualityParameterName ? item.qualityParameterName : '-'}</td>
                                                                <td style={{textAlign:"center"}}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                        <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    STPMasterQualityParameterDataPopupShow ?
                        <STPMasterQualityParameterDataPopup
                            open={STPMasterQualityParameterDataPopupShow}
                            popupHeading="Work Name"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}